/**
 * Staff "Assigned to you" policy list.
 * All code lives under OfficePolicyManagement; no imports from backup directory.
 */
import StaffOfficePolicyList from "./StaffOfficePolicyList";
export default StaffOfficePolicyList;
